(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stirwake-header"]) return;
  try {
    
  document.querySelectorAll('[data-swh-cta]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var target = document.querySelector('.sw-offers');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stirwake-product"]) return;
  try {
    
  document.querySelectorAll('[data-sw-root]').forEach(function (root) {
    function sync(input) {
      root.querySelectorAll('[data-sw-price-out]').forEach(function (el) { el.textContent = input.dataset.price; });
      var compare = root.querySelector('[data-sw-compare-out]');
      var save = root.querySelector('[data-sw-save-out]');
      if (compare) { compare.textContent = input.dataset.compare || ''; compare.hidden = !input.dataset.compare; }
      if (save) { save.textContent = input.dataset.save || ''; save.hidden = !input.dataset.save; }
    }
    var inputs = root.querySelectorAll('input[name="quantity"]');
    inputs.forEach(function (input) {
      input.addEventListener('change', function () { sync(input); });
      if (input.checked) sync(input);
    });

    // Buy Now: empty the cart, add the chosen pack, go straight to checkout.
    var form = root.querySelector('[data-sw-form]');
    if (form && window.fetch) {
      var busy = false;
      form.addEventListener('submit', function (event) {
        if (busy) { event.preventDefault(); return; }
        var idInput = form.querySelector('input[name="id"]');
        var picked = form.querySelector('input[name="quantity"]:checked');
        if (!idInput || !picked) return;
        event.preventDefault();
        busy = true;
        var rootUrl = root.dataset.rootUrl || '/';
        var buttons = root.querySelectorAll('[data-sw-buy]');
        buttons.forEach(function (btn) {
          btn.disabled = true;
          var label = btn.querySelector('[data-sw-buy-label]');
          if (label) label.textContent = 'Taking you to checkout…';
        });
        var json = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
        fetch(rootUrl + 'cart/clear.js', { method: 'POST', headers: json })
          .then(function () {
            return fetch(rootUrl + 'cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ id: Number(idInput.value), quantity: Number(picked.value) }) });
          })
          .then(function (response) {
            if (!response.ok) throw new Error('add failed');
            window.location.href = rootUrl + 'checkout';
          })
          .catch(function () {
            buttons.forEach(function (btn) { btn.disabled = false; });
            form.submit();
          });
      });
    }

    // Video clips: loop only the chosen fragment, play only while on screen.
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var clipVideos = root.querySelectorAll('[data-sw-clip]');
    clipVideos.forEach(function (video) {
      var start = parseFloat(video.dataset.start) || 0;
      var end = parseFloat(video.dataset.end) || 0;
      video.addEventListener('loadedmetadata', function () { if (video.currentTime < start) video.currentTime = start; });
      video.addEventListener('timeupdate', function () {
        if (end && video.currentTime >= end) { video.currentTime = start; if (video.paused && !reduceMotion) video.play().catch(function () {}); }
      });
      video.addEventListener('ended', function () { video.currentTime = start; video.play().catch(function () {}); });
    });
    if (clipVideos.length && 'IntersectionObserver' in window && !reduceMotion) {
      var watcher = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.play().catch(function () {}); } else { entry.target.pause(); }
        });
      }, { threshold: 0.4 });
      clipVideos.forEach(function (video) { watcher.observe(video); });
    }

    var slides = root.querySelector('[data-sw-slides]');
    if (!slides) return;
    var thumbs = root.querySelectorAll('[data-sw-thumb]');
    var count = root.querySelector('[data-sw-count]');
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        slides.scrollTo({ left: slides.clientWidth * Number(btn.dataset.swThumb), behavior: 'smooth' });
      });
    });
    slides.addEventListener('scroll', function () {
      var i = Math.round(slides.scrollLeft / slides.clientWidth);
      if (count) count.textContent = i + 1;
      thumbs.forEach(function (btn, n) {
        if (n === i) { btn.setAttribute('aria-current', 'true'); } else { btn.removeAttribute('aria-current'); }
      });
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();
})();
